export default __webpack_public_path__ + "static/media/club-category.3b5a9d28.jpg";